import { render, staticRenderFns } from "./ProductionStorageIndex.vue?vue&type=template&id=06a43e4b&"
import script from "./ProductionStorageIndex.vue?vue&type=script&lang=js&"
export * from "./ProductionStorageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports